import { useEffect } from 'react';
import gsap from 'gsap';

const HeyEdLoader = () => {
  useEffect(() => {
    const ctx = gsap.context(() => {
      const timeline = gsap.timeline();

      timeline
        .to('.hey', { opacity: 1, duration: 0.2, ease: 'power2.out' })
        .to('.ed', { opacity: 1, y: 0, duration: 0.8, ease: 'power4.out', delay: 1 })
        .to('.dot', { opacity: 1, y: 0, duration: 0.8, ease: 'bounce.out' });

      const addHoverAnimation = (selector: string) => {
        document.querySelectorAll(selector).forEach(element => {
          element.addEventListener('mouseenter', () => {
            gsap.to(element, { rotation: 5, duration: 0.1, yoyo: true, repeat: 3, ease: 'none' });
          });
        });
      };

      addHoverAnimation('.ed');
      addHoverAnimation('.dot');
    });

    return () => ctx.revert();
  }, []);

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="relative inline-block">
        <div className="font-bitter inline-block cursor-pointer text-[44px] font-medium">
          <span className="hey text-gray-700 opacity-0">Hey</span>
          <span className="ed text-primary inline-block translate-y-12 opacity-0">Ed</span>
          <span className="dot text-primary inline-block -translate-y-24 opacity-0">.</span>
        </div>
      </div>
    </div>
  );
};

export default HeyEdLoader;
